export enum MainModuleType{
    ADMINCENTRE = 'navigation.admin.title',
    CONTROLCENTRE = 'navigation.control.title',
    REPORTCENTRE = 'navigation.report.title',
    CUSTOMERCENTRE = 'navigation.customer.title',
    COPCENTRE = 'navigation.cop.title',
    RESOURCECENTRE = 'navigation.resource.title',
    COMMANDCENTRE = 'navigation.command.title',
    DASHBOARDCENTRE = 'navigation.dashboard.title',
    STAGINGCENTRE = 'navigation.staging.title',
    STAGINGCENTREMENUPLANNER = 'navigation.staging.planner.title',
    TISSLPAYCENTRE = 'navigation.tisslpay.title'
}
